export default "__VITE_ASSET__CNyZUiER__"